var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGlobecomponent = function SvgGlobecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4629",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8,
    d: "M23.1 12c0 6.13-4.97 11.1-11.1 11.1S.9 18.13.9 12 5.87.9 12 .9 23.1 5.87 23.1 12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF4629",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1 12h22M12 1c3.127 3.143 4.903 6.744 5 11-.097 4.256-1.873 7.857-5 11-3.127-3.143-4.903-6.744-5-11 .097-4.256 1.873-7.857 5-11"
  })));
};
export default SvgGlobecomponent;